import {
  useWSModalCustom,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import React from "react";

type Props = WSModalCustomProps<boolean>;

export const ModalStaleRevision: React.FC<Props> = ({ ...modalProps }) => (
  <WSModal
    title="Form has been updated"
    size="S"
    actions={{
      buttons: [
        {
          kind: "Tertiary",
          label: "Cancel",
          onClick: () => modalProps.onClose(false)
        },
        {
          label: "Reload form",
          onClick: () => modalProps.onClose(true)
        }
      ]
    }}
    {...modalProps}
  >
    <WSList gap="M">
      <WSText.ParagraphSm color="gray600">
        A newer version of this form is available. Reload to get the latest
        version. Some answers may need to be re-entered.
      </WSText.ParagraphSm>
    </WSList>
  </WSModal>
);

export const useModalStaleRevision = () => useWSModalCustom(ModalStaleRevision);
